import { SENSOR_READING_TYPES } from '../constants'

const getChartTypeKey = (pageSlug, reading) => `${pageSlug}::${reading}`

const getDefaultChartType = reading =>
  reading === SENSOR_READING_TYPES.MIC_COUNT ? 'column' : 'line'

const resolveChartType = (chartTypes, pageSlug, reading) =>
  chartTypes[getChartTypeKey(pageSlug, reading)] || getDefaultChartType(reading)

export { getChartTypeKey, getDefaultChartType, resolveChartType }
